// Re-export the shared formatters so the web UI never drifts from the single
// source of truth in @petrotrack/shared. Only web-specific presentation
// helpers (Tailwind color classes) live here.
export { formatNaira, formatNumber, formatLiters, formatCalibration } from '@petrotrack/shared'

// Tailwind class map for fuel-product chips/badges (web-only presentation).
export const FUEL_COLORS = {
  PMS: { bg: 'bg-blue-100', text: 'text-blue-700' },
  AGO: { bg: 'bg-amber-100', text: 'text-amber-700' },
  DPK: { bg: 'bg-orange-100', text: 'text-orange-700' },
  LPG: { bg: 'bg-green-100', text: 'text-green-700' },
}
